import React, { useState } from 'react';
import '../css/Header.css';
import LanguageSelector from './LanguageSelector';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const currentPath = window.location.pathname;

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        setActiveSubmenu(null);
    };

    const handleSubmenuClick = (e, id) => {
        if (window.innerWidth <= 1024) {
            e.preventDefault();
            setActiveSubmenu(activeSubmenu === id ? null : id);
        }
    };

    const menuItems = [
        {
            id: 'about', label: 'About', href: '/about',
            sub: [
                { label: 'Our Odyssey', href: '/about/our-odyssey' },
                { label: 'Board of Directors', href: '/about/board' },
                { label: 'Senior Management Team', href: '/about/management' },
                { label: 'Corporate Governance', href: '/corporate-governance.html' },
                { label: 'Quality', href: '/quality.html' },
                { label: 'Safety is Priority', href: '/safety-is-priority.html' },
                { label: 'Energy Management', href: '/energy-management.html' },
                { label: 'CSR Environment', href: '/csr-environment.html' },
                { label: 'Awards', href: '/awards.html' },
                { label: 'Testimonials', href: '/testimonial.html' },
                { label: 'Key Strengths', href: '/key-strength.html' },
            ]
        },
        {
            id: 'services', label: 'Services', href: '/services',
            sub: [
                { label: 'Ship Repairs', href: '/ship-repairs.html' },
                { label: 'Shipbuilding', href: '/shipbuilding.html' },
                { label: 'Afloat Repairs', href: '/afloat-repairs.html' },
                { label: 'Offshore Engineering', href: '/offshore-engineering.html' },
                { label: 'Heavy Engineering', href: '/heavy-engineering.html' },
                { label: "OEM'S", href: "/oem's-in-colombo.html" },
            ]
        },
        {
            id: 'facilities', label: 'Facilities', href: '/facilities',
            sub: [
                { label: 'Shipyard Layout', href: '/shipyard-layout.html' },
                { label: 'Drydocks', href: '/drydocks.html' },
                { label: 'Workshops', href: '/workshops.html' },
                { label: 'Classification Societies', href: '/classification-societies.html' },
            ]
        },
        { id: 'agents', label: 'Agents', href: '/agents' },
        {
            id: 'financials', label: 'Financials', href: '/financials',
            sub: [
                { label: 'Annual Reports', href: '/annual-reports.html' },
                { label: 'Investor Relations', href: '/investor-relations.html' },
                { label: 'Statistics', href: '/statistics.html' },
            ]
        },
        {
            id: 'news', label: 'News', href: '/news',
            sub: [
                { label: 'Main News', href: '/news' },
                { label: 'Newsletter', href: '/newsletter' },
                { label: 'Local Tenders', href: '/tenders' },
            ]
        },
        {
            id: 'resources', label: 'Resources', href: '/working-at-colombo-dockyard',
            sub: [
                { label: 'Working at Colombo Dockyard', href: '/working-at-colombo-dockyard' },
                { label: 'What We Offer', href: '/what-we-offer.html' },
                { label: 'Training', href: '/training.html' },
                { label: 'Recognition of Employees', href: '/recognition-of-employees.html' },
                { label: 'Opportunities', href: '/opportunities.html' },
            ]
        },
        { id: 'contact', label: 'Contact Us', href: '/contact-us' },
    ];

    return (
        <header id="header-wrapper">
            <div className="center-container">
                <div id="main-logo">
                    <a href="/">
                        <img alt="Colombo Dockyard PLC" src="/wp-content/themes/cdl/images/main-logo.png" />
                    </a>
                </div>

                <div className="header-l-sec">
                    <nav id="main-menu" className={isMenuOpen ? 'active' : ''}>
                        <ul>
                            {menuItems.map(item => (
                                <li
                                    key={item.id}
                                    className={item.sub ? (activeSubmenu === item.id ? 'submenu-open' : '') : ''}
                                    onMouseEnter={() => window.innerWidth > 1024 && setActiveSubmenu(item.id)}
                                    onMouseLeave={() => window.innerWidth > 1024 && setActiveSubmenu(null)}
                                >
                                    <a
                                    href = {item.href}
                                    onClick = {item.sub ? (e) => handleSubmenuClick(e, item.id) : undefined}
                                    className={currentPath === item.href || (item.sub && item.sub.some(s => currentPath === s.href)) ? 'active-link' : ''}
                                    >
                                        {item.label}
                                    </a>
                                    {item.sub && (
                                        <ul className="sub-menu">
                                            {item.sub.map((s, i) => (
                                                <li key={i}>
                                                    <a
                                                    href={s.href}
                                                    className = {currentPath === s.href ? 'active-link' : ''}
                                                    >
                                                        {s.label}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div id="weather-sec">
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 8 }}>
                            <button
                                className="cdl-search-btn"
                                onClick={() => setSearchOpen(!searchOpen)}
                            />
                            {searchOpen && (
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        const q = e.target.q.value.trim();
                                        if (q) window.location.href = `/news?search=${encodeURIComponent(q)}`;
                                    }}
                                    style={{ display: 'flex', alignItems: 'center', gap: 6 }}
                                >
                                    <input
                                        name="q"
                                        autoFocus
                                        placeholder="Search..."
                                        style={{
                                            border: '1px solid #1b3e93',
                                            borderRadius: 4,
                                            padding: '4px 10px',
                                            fontSize: 13,
                                            outline: 'none',
                                            width: 150,
                                        }}
                                    />
                                </form>
                            )}
                        </div>
                        {/* <LanguageSelector /> */}
                        <div className="weather-widget">
                            <img src="/wp-content/uploads/2024/08/50-years-logo.png" alt="50 Years Anniversary" />
                        </div>
                    </div>

                    <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
                        <span className={isMenuOpen ? 'open' : ''}></span>
                        <span className={isMenuOpen ? 'open' : ''}></span>
                        <span className={isMenuOpen ? 'open' : ''}></span>
                    </button>
                </div>
            </div>

            {/* Overlay to close menu */}
            {isMenuOpen && (
                <div
                    className="mobile-menu-overlay"
                    onClick={toggleMenu}
                />
            )}
        </header>
    );
};

export default Header;
